<template>
  <div id="app">
    <vs-notify group="alert">
      <template slot="body" slot-scope="props">
        <b-alert
          class="mb-0"
          show
          :variant="props.item.type"
          @dismissed="props.close"
          :dismissible="true"
        >
          {{ props.item.text }}
        </b-alert>
      </template>
    </vs-notify>
    <component :is="layout">
      <transition
        name="fade-transform"
        mode="out-in"
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
      >
        <router-view :key="$route.fullPath" />
      </transition>
    </component>
  </div>
</template>

<script>
const DefaultLayout = () => import('./layouts/default.vue');
const EmptyLayout = () => import('./layouts/empty.vue');

export default {
  components: {
    DefaultLayout,
    EmptyLayout
  },

  computed: {
    layout() {
      return `${this.$route.meta.layout || 'default'}-layout`;
    }
  },

  methods: {
    afterEnter() {
      document.querySelector('.app-content') &&
        document.querySelector('.app-content').classList.remove('wrapper');
    },
    beforeLeave() {
      document.querySelector('.app-content') &&
        document.querySelector('.app-content').classList.add('wrapper');
    }
  }
};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
}
#app {
  min-height: 100%;
}
</style>
